<div class="d-flex flex-column justify-content-between h-100">
  <div style="flex-basis: 40px" id="header">
    @if (selectedUser) {
      <div class="d-flex align-items-center px-3 py-2 cursor header border"
        (click)="navigateToViewProfile(selectedCurrentUser)">
        <div class="d-flex justify-content-center align-items-center position-relative cursor-pointer">
          <img [src]="selectedUser.ImgUrl || 'assets/images/No-Image.png'" class="flex-row rounded-pill contact-img"
            width="32" height="32" alt="pic">
            <div class="online-dot"></div>
          </div>
          <div class="ms-2 cursor-pointer">{{selectedUser.Name}}</div>
        </div>
      }
    </div>

    <div class="flex-grow-1 h-100 mt-2" style="overflow-y: auto;" #scrollContainer
      [scrollTop]="scrollContainer.scrollHeight">
      <div class="message_container">
        @if (!messagesLoaded) {
          <div class="d-flex justify-content-center align-items-center h-100">
            <p-progressSpinner class="fs-5 small-spinner"></p-progressSpinner>
            <div class="ms-2">{{ 'messages.loadingMessages' | transloco }}</div>
          </div>
        }
        @if (messagesLoaded) {
          @for (message of messages; track message) {
            <div class="message-row">
              <!-- Artist Logic -->
              @if (authConfig.IsArtist) {
                <div class="mt-2">
                  <div class="message message mb-2"
                    [ngClass]="{'sent': message.ArtistId === loggedInUserId && message.IsSenderAnArtist, 'received': !message.IsSenderAnArtist, 'event-message': message.IsEventMessage, 'no-border': message.EventHeading === 'Product Sold'}">
                    @if (!message.IsEventMessage) {
                      <div class="d-flex">
                        @if (!message.IsSenderAnArtist) {
                          <img [src]="selectedCurrentUser.ImgUrl || 'assets/images/No-Image.png'"
                            class="rounded-pill contact-img cursor-pointer" width="32" height="32" alt="pic"
                            >
                        }
                        @if (message.ArtistId === loggedInUserId && message.IsSenderAnArtist) {
                          <img [src]="loggedInUser?.PersonalImgUrl || loggedInUser?.LogoUrl || 'assets/images/No-Image.png'"
                            class="rounded-pill contact-img cursor-pointer" width="32" height="32" alt="pic"
                            >
                        }
                        <div class="ms-2">
                          @if (!message.IsSenderAnArtist) {
                            <div class="fw-semibold text-dark cursor-pointer"
                              (click)="navigateToViewProfile(selectedCurrentUser)">
                              {{selectedCurrentUser.Name}}
                            </div>
                          }
                          @if (message.ArtistId === loggedInUserId && message.IsSenderAnArtist) {
                            <div class="fw-semibold">
                              {{loggedInUser?.FirstName}} {{ 'messages.you' | transloco }}
                            </div>
                          }
                          <div class="message-content text-muted">{{ message.TextMessage }}</div>
                        </div>
                        <div class="ms-auto text-muted text-end">
                          {{ message.SentDate | date: 'shortTime' }}
                        </div>
                      </div>
                    }
                    <!-- Event Message -->
                    @if (message.IsEventMessage) {
                      <div class="event-details p-2 mb-2">
                        <div class="d-flex justify-content-between align-items-center" (click)="ViewEventsDetail(message)">
                          <div class="fw-bold cursor-pointer fs-5 event-message-heading">
                            {{ message.EventHeading }}
                          </div>
                          <div class="message-time text-muted fst-italic">
                            {{ message.SentDate | date: 'medium' }}
                          </div>
                        </div>
                        <div>
                          @if (message.TextMessage) {
                            <span class="text-muted fst-italic cursor-pointer">
                              {{ message.TextMessage}}
                            </span>
                          }
                        </div>
                        <div class="message-content text-muted mb-2 fst-italic">
                          @if (message.EventHeading == 'Consignment Dispatch' || message.EventHeading == 'Consignment Accepted') {
                            {{ message.TextMessage }}
                          }
                          @if (message.EventHeading == 'Product Sold') {
                            <div
                              class="custom-height-container-artist mt-2 custom-product-container cursor-pointer position-relative">
                              <div class="custom-img-container">
                                <img [src]="message.SoldProductDetailOnChatBox?.ProductImgUrl || 'assets/images/No-Image.png'"
                                  class="custom-img-height-artist custom-img rounded-cube border" alt="Product Image">
                                </div>
                                @if (message.SoldProductDetailOnChatBox) {
                                  <div class="d-flex flex-column p-1 mb-2 w-100">
                                    <div class="d-flex flex-row justify-content-between position-relative">
                                      <div class="text-uppercase fw-semibold ellipsis">
                                        <a href="javascript:void(0);" class="text-uppercase text-dark fw-semibold"
                                          pTooltip="{{ message.SoldProductDetailOnChatBox.Name }}" style="font-size: 1rem;">
                                          {{ message.SoldProductDetailOnChatBox.Name }}
                                        </a>
                                        <div class="text-uppercase" style="font-size: 0.8rem;">{{ 'messages.galleryName' | transloco }}
                                        {{message.SoldProductDetailOnChatBox.GalleryBusinessName}}</div>
                                        <div class="text-uppercase" style="font-size: 0.8rem;">{{ 'messages.soldPrice' | transloco }}
                                        ${{message.SoldProductDetailOnChatBox.SoldPrice}}</div>
                                        @if (message.SoldProductDetailOnChatBox.SoldOnPlateform !== 'ArtFlow') {
                                          <div class="text-uppercase" style="font-size: 0.8rem;"
                                            >{{ 'messages.platform' | transloco }}
                                          {{message.SoldProductDetailOnChatBox.SoldOnPlateform}}</div>
                                        }
                                        @if (message.SoldProductDetailOnChatBox.SoldOnPlateform !== 'ArtFlow') {
                                          <div class="text-uppercase productsold-detail"
                                            >{{ 'messages.targetPlatformSoldPrice' | transloco }} {{message.SoldProductDetailOnChatBox.TargetPlateFormSoldPrice}}
                                            @if (message.SoldProductDetailOnChatBox.TargertPlateFormSoldProductCurrencySymbol == 'USD') {
                                              $
                                            }
                                            @if (message.SoldProductDetailOnChatBox.TargertPlateFormSoldProductCurrencySymbol == 'JPY') {
                                              ¥
                                            }
                                            @if (message.SoldProductDetailOnChatBox.TargertPlateFormSoldProductCurrencySymbol == 'PKR') {
                                              PKR
                                            }
                                          </div>
                                        }
                                        @if (message.SoldProductDetailOnChatBox.ExchangeRateOnSoldProduct !== 1) {
                                          <div class="text-uppercase" style="font-size: 0.8rem;"
                                            >{{ 'messages.exchangeRate' | transloco }}
                                          {{message.SoldProductDetailOnChatBox.ExchangeRateOnSoldProduct}}</div>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
                <!-- Gallery Logic -->
                @if (authConfig.IsGallery) {
                  <div class="mt-2">
                    <div class="message mb-2"
                      [ngClass]="{'sent': message.GalleryId === loggedInUserId && !message.IsSenderAnArtist, 'received': message.IsSenderAnArtist, 'event-message': message.IsEventMessage, 'no-border': message.EventHeading === 'Product Sold'}">
                      @if (!message.IsEventMessage) {
                        <div class="d-flex">
                          @if (message.IsSenderAnArtist) {
                            <img [src]="selectedCurrentUser.ImgUrl || 'assets/images/No-Image.png'" class="rounded-pill contact-img"
                              width="32" height="32">
                          }
                          @if (message.GalleryId === loggedInUserId && !message.IsSenderAnArtist) {
                            <img [src]="loggedInUser?.PersonalImgUrl || loggedInUser?.LogoUrl || 'assets/images/No-Image.png'"
                              class="rounded-pill contact-img" width="32" height="32"
                              >
                          }
                          <div class="ms-2">
                            @if (message.IsSenderAnArtist) {
                              <div class="fw-semibold text-dark cursor-pointer"
                                (click)="navigateToViewProfile(selectedCurrentUser)">
                                {{selectedCurrentUser.Name}}
                              </div>
                            }
                            @if (message.GalleryId === loggedInUserId && !message.IsSenderAnArtist) {
                              <div class="fw-semibold">
                                {{loggedInUser?.FirstName}} {{ 'messages.you' | transloco }}
                              </div>
                            }
                            <div class="message-content text-muted">{{ message.TextMessage }}</div>
                          </div>
                          <div class="ms-auto text-muted text-end">
                            {{ message.SentDate | date: 'shortTime' }}
                          </div>
                        </div>
                      }
                      <!-- Event Message -->
                      @if (message.IsEventMessage) {
                        <div class="event-details p-2">
                          <div class="d-flex justify-content-between align-items-center mb-2"
                            (click)="ViewEventsDetail(message)">
                            <div class="fw-bold cursor-pointer fs-5 event-message-heading">
                              {{ message.EventHeading }}
                            </div>
                            <div class="message-time text-muted fst-italic">
                              {{ message.SentDate | date: 'medium' }}
                            </div>
                          </div>
                          <div>
                            @if (message.TextMessage) {
                              <span class="text-muted fst-italic cursor-pointer">
                                {{ message.TextMessage}}
                              </span>
                            }
                          </div>
                          <div class="message-content text-muted mb-2 fst-italic">
                            @if (message.EventHeading == 'Consignment Dispatch' || message.EventHeading == 'Consignment Accepted') {
                              {{ message.TextMessage }}
                            }
                            @if (message.EventHeading == 'Product Sold') {
                              <div
                                class="custom-height-container mt-2 custom-product-container cursor-pointer position-relative">
                                <div class="custom-img-container">
                                  <img [src]="message.SoldProductDetailOnChatBox?.ProductImgUrl || 'assets/images/No-Image.png'"
                                    class="custom-img rounded-cube border" alt="Product Image">
                                  </div>
                                  @if (message.SoldProductDetailOnChatBox) {
                                    <div class="d-flex flex-column p-1 mb-2 w-100">
                                      <div class="d-flex flex-row justify-content-between position-relative">
                                        <div class="text-uppercase fw-semibold ellipsis">
                                          <a href="javascript:void(0);"
                                            class="text-uppercase text-dark fw-semibold productsold-name"
                                            pTooltip="{{ message.SoldProductDetailOnChatBox.Name }}">
                                            {{ message.SoldProductDetailOnChatBox.Name }}
                                          </a>
                                          <div class="text-uppercase productsold-detail">{{ 'messages.soldPriceColon' | transloco }}
                                          ${{message.SoldProductDetailOnChatBox.SoldPrice}}</div>
                                          @if (message.SoldProductDetailOnChatBox.SoldOnPlateform !== 'ArtFlow') {
                                            <div class="text-uppercase productsold-detail"
                                              >{{ 'messages.platform' | transloco }}
                                            {{message.SoldProductDetailOnChatBox.SoldOnPlateform}}</div>
                                          }
                                          @if (message.SoldProductDetailOnChatBox.SoldOnPlateform !== 'ArtFlow') {
                                            <div class="text-uppercase productsold-detail"
                                              >{{ 'messages.targetPlatformSoldPrice' | transloco }} {{message.SoldProductDetailOnChatBox.TargetPlateFormSoldPrice}}
                                              @if (message.SoldProductDetailOnChatBox.TargertPlateFormSoldProductCurrencySymbol == 'USD') {
                                                $
                                              }
                                              @if (message.SoldProductDetailOnChatBox.TargertPlateFormSoldProductCurrencySymbol == 'JPY') {
                                                ¥
                                              }
                                              @if (message.SoldProductDetailOnChatBox.TargertPlateFormSoldProductCurrencySymbol == 'PKR') {
                                                PKR
                                              }
                                            </div>
                                          }
                                          @if (message.SoldProductDetailOnChatBox.ExchangeRateOnSoldProduct !== 1) {
                                            <div class="text-uppercase productsold-detail"
                                              >{{ 'messages.exchangeRate' | transloco }}
                                            {{message.SoldProductDetailOnChatBox.ExchangeRateOnSoldProduct}}</div>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            } @else {
              <div class="no-messages-text">
                <div class="container-fluid">
                  <div class="d-flex align-items-center justify-content-center text-white p-4">
                    <h2>{{ 'messages.welcomeToYourInbox' | transloco }}</h2>
                    <h3>{{ 'messages.letsGetYouStarted' | transloco }}</h3>
                  </div>
                </div>
              </div>
            }

            <!-- No Messages Template -->
          </div>
        </div>

        <!-- Message Input Section -->
        @if (sendMessageData) {
          <div class="mt-1" style="flex-basis: 40px;">
            <div class="d-flex">
              <input type="text" class="form-control field position-relative" name="newMessage"
                [(ngModel)]="sendMessageData.TextMessage" [ngModelOptions]="{standalone: true}" (keydown.enter)="sendMessage()"
                [placeholder]="'messages.enterYourMessageHere' | transloco" />
                <div class="emoji-icon" (click)="openEmojiDialog()">😍</div>
                <div class="me-1 ms-1 mb-1">
                  <button type="button" class="btn btn-success text-white" [disabled]="!sendMessageData.TextMessage"
                    (click)="sendMessage()">
                    <i class="fa fa-paper-plane"></i>
                  </button>
                </div>
              </div>
            </div>
          }
        </div>

        <!-- Emoji-Dialog -->
        @if (displayEmojiDialog) {
          <app-emoji-list [showDialog]="displayEmojiDialog" (onClose)="closeEmojiDialog($event)"
          (emojiClick)="addEmoji($event)"></app-emoji-list>
        }